import React from "react";
import { registerView, ViewComponent } from "@frui.ts/views";
import OutagesViewModel from "../../../viewModels/common/outagesViewModel";
import { observer } from "mobx-react-lite";
import ReactMarkdown from "react-markdown";
import Alert from "../alertWithInfoIcon/alertWithInfoIcon";
import { SystemComponent } from "../../../models/outage";

const OutagesView: ViewComponent<OutagesViewModel> = observer(({ vm }) => {
  if (!vm.outages.length) {
    return null;
  }

  return (
    <div className={vm.allowToClose ? "mt-1 mb-lg-n2" : "mt-n4 mb-4"}>
      {vm.outages.map(outage => {
        const message = vm.outageMessage(outage);
        const onClose = vm.allowToClose ? () => vm.closeOutage(outage) : undefined;
        let variant = "warning";

        if (
          [SystemComponent.ESHOP, SystemComponent.PAY_GATE].includes(outage.systemComponentCode as SystemComponent) &&
          outage.validSince <= new Date()
        ) {
          variant = "danger";
        }

        return (
          <Alert className="mb-2" variant={variant} key={message} onClose={onClose} dismissible={vm.allowToClose}>
            <ReactMarkdown>{message}</ReactMarkdown>
          </Alert>
        );
      })}
    </div>
  );
});

registerView(OutagesView, OutagesViewModel);
